"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcNavi = (props) => ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 5.91486H3V4.41486H17V5.91486ZM17 10.5H3V9H17V10.5ZM3 15.5H17V14H3V15.5Z" }) })));
exports.default = IcNavi;
